export default {"src":"/_next/static/media/2-year-guarantee.6d0c7c34.svg","height":409,"width":561};